














































































































































import {Component, Mixins, Prop, Watch, Ref} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import ReadOnlyInputForIE from '@/mixins/ReadOnlyInputForIE'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import {Form, FormItem, InputNumber, Row, Col} from 'element-ui'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import SelectDatePopup from '@/pages/issue/popup/SelectDate.vue'
import TaxInputPopup from '@/pages/issue/popup/TaxInput.vue'
import ToggleCollapseButton from '@/pages/issue/components/ToggleCollapseButton.vue'
import AmountInput from '@/pages/issue/components/AmountInput.vue'
import {ItemFormData} from '@/pages/issue/constants/init-item'
import {
  calcAmountsFromTotalAmount,
  calcAmountsFromUnitCost,
  calcTaxationTaxFromSupplyCost,
  calcAmountsFromUnitCostAndTax,
} from '@/pages/issue/utils/calculate-amounts'
import {inputFormat, issueDateFormat} from '@/pages/issue/constants/issue-date-format'
import {toJSDateFormat, jsDateToFormat, getLocalTime, validatePurchaseDate} from '@/pages/issue/utils/date'
import {DateTime} from 'luxon'
import toCurrency from '@/filters/to-currency'
import {TaxType} from '@/store/modules/issue/types'

@Component({
  components: {
    [Form.name]: Form, [FormItem.name]: FormItem, [InputNumber.name]: InputNumber,
    [Row.name]: Row, [Col.name]: Col, [CollapseTransition.name]: CollapseTransition,
    SelectDatePopup, ToggleCollapseButton, TaxInputPopup, AmountInput, FloatingLabelInput,
  },
  filters: {
    toCurrency,
  },
  data() {
    return {inputFormat, issueDateFormat}
  },
  methods: {toCurrency, toJSDateFormat, jsDateToFormat},
})
export default class ItemForm extends Mixins(Translation, PopupHandler, ReadOnlyInputForIE, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: () => ({}), type: Object}) value: ItemFormData
  @Prop({default: '', type: String}) writeDate: string
  @Prop({default: false, type: Boolean}) isSelectedTaxFree: boolean
  @Prop({default: false, type: Boolean}) isMultiData: boolean

  @Ref('formRef') readonly formRef!: Form

  item: ItemFormData | any = {}
  selectedDate: Date | '' = ''
  visibleExtraData: boolean = false
  limitPrecisionNumber: number = 2

  get taxType(): TaxType {
    return this.item.taxFree ? '면세' : this.item.tax === 0 ? '영세' : '과세'
  }

  get taxationTaxAmount(): number {
    return calcTaxationTaxFromSupplyCost(this.item.supplyCost)
  }

  get isEnteredExtraData(): boolean {
    return Boolean(this.item.spec || this.item.remark || this.item.purchaseDate)
  }

  get localTime(): Date {
    return getLocalTime()
  }

  get defaultDate(): Date {
    return this.writeDate ? toJSDateFormat(this.writeDate) : this.localTime
  }

  get writeDateToFormatInput(): string {
    return jsDateToFormat(toJSDateFormat(this.writeDate), inputFormat)
  }

  get purchaseDatePlaceholder(): string {
    if(!this.selectedDate && this.writeDate) {
      return this.writeDateToFormatInput
    }
    return `${this.ts('purchase-date')}`
  }

  get disabledDates(): object {
    if(!this.writeDate) {
      return {
        from: this.localTime
      }
    }
    const writeDate = DateTime.fromFormat(this.writeDate, issueDateFormat)
    const year = writeDate.year
    const month = writeDate.month
    const day = writeDate.day
    const toDate = DateTime.local(year, month).toJSDate()
    const fromDate = DateTime.local(year, month, day, 23, 59, 59).toJSDate()
    return {
      to: toDate,
      from: fromDate,
    }
  }

  get taxTypeError(): boolean {
    return !this.item.taxFree && this.isSelectedTaxFree
  }

  get validatePurchaseDateError() {
    return validatePurchaseDate(this.writeDate, this.item.purchaseDate)
  }

  get rules(): object {
    const {ts} = this
    return {
      itemName: [
        {
          required:  true,
          message: `${ts('item')}명을 ${ts('input')}해주세요`,
          trigger: 'blur',
        }
      ],
      unitCost: [
        {
          validator: (_, value, callback) => {
            if(this.isPrecisionError(value)) {
              return callback(new Error(`소수점은 ${this.limitPrecisionNumber}자리까지 ${ts('input')} 가능합니다`))
            }
            return callback()
          },
          trigger: ['blur', 'change'],
        }
      ],
      qty: [
        {
          validator: (_, value, callback) => {
            if(this.isPrecisionError(value)) {
              return callback(new Error(`소수점은 ${this.limitPrecisionNumber}자리까지 ${ts('input')} 가능합니다`))
            }
            const MAX_LENGTH = 12
            if(String(value).length > MAX_LENGTH) {
              return callback(new Error(`${MAX_LENGTH}자리까지 ${ts('input')} 가능합니다`))
            }
            return callback()
          },
          trigger: ['blur', 'change'],
        }
      ],
      taxType: [
        {
          validator: (_, value, callback) => {
            if(this.taxTypeError) {
              return callback(new Error(' '))
            }
            return callback()
          },
          trigger: ['change', 'blur'],
        }
      ],
      purchaseDate: [
        {
          validator: (_, value, callback) => {
            if(this.validatePurchaseDateError === 'from-date-error') {
              return callback(new Error(`${ts('purchase-date')}는 상품을 제공한 날짜(${this.writeDateToFormatInput})보다 이후일 수 없습니다`))
            }
            if(this.validatePurchaseDateError === 'to-date-error') {
              return callback(new Error(`${ts('purchase-date')}는 상품을 제공한 달(${this.writeDateToFormatInput})보다 이전일 수 없습니다`))
            }
            return callback()
          },
          trigger: ['blur', 'change'],
        }
      ]
    }
  }

  @Watch('value')
  __value(value) {
    this.item = value
  }

  @Watch('item', {deep: true})
  __item(value) {
    this.$emit('input', value)
  }

  @Watch('taxType')
  __taxType(value) {
    this.item.taxType = value
  }

  @Watch('selectedDate')
  __selectedDate(value) {
    this.item.purchaseDate = jsDateToFormat(value, issueDateFormat)
  }

  @Watch('isEnteredExtraData', {immediate: true})
  __isEnteredExtraData(value) {
    if(value) {
      this.toggleExtraData(true)
    }
  }

  mounted() {
    this.item = this.value
    if(this.item.purchaseDate) {
      this.selectedDate = toJSDateFormat(this.item.purchaseDate)
    }
  }

  isPrecisionError(value): boolean {
    const [,decimalValue] = String(value).split('.')
    return decimalValue?.length > this.limitPrecisionNumber
  }

  toggleExtraData(value) {
    this.visibleExtraData = value
  }

  onSelectedDate(date) {
    this.selectedDate = date
  }

  onSetTax({tax, taxFree}) {
    this.item.tax = tax
    this.item.taxFree = taxFree
    const {supplyCost, totalAmount} = calcAmountsFromUnitCostAndTax(this.item.unitCost, this.item.qty, this.item.tax)
    this.item.supplyCost = supplyCost
    this.item.totalAmount = totalAmount
  }

  onHandleTotalAmount() {
    const {unitCost, tax, supplyCost} = calcAmountsFromTotalAmount(this.item.totalAmount, this.item.qty)
    this.item.unitCost = unitCost
    this.item.tax = tax
    this.item.supplyCost = supplyCost
  }

  onHandleUnitCost() {
    const {supplyCost, tax, totalAmount} = calcAmountsFromUnitCost(this.item.unitCost, this.item.qty, this.item.taxFree)
    this.item.tax = tax
    this.item.supplyCost = supplyCost
    this.item.totalAmount = totalAmount
  }

}
